// Чаты исполнителя (сервер — chat.js, /api/chat/e/*): вход, как и во всём API
// приложения, по google_user_id из getRequestParams.
import { getRequestParams } from "../../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper"
import fetchWithTimeout, { getHttpParams, getRequestUrl } from "../../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid"

async function call(path, extra) {
    const params = getRequestParams()
    Object.keys(extra || {}).forEach((key) => {
        const value = extra[key]
        if (value !== undefined && value !== null) params[key] = value
    })
    let data
    try {
        const response = await fetchWithTimeout(getRequestUrl() + "chat/e/" + path, getHttpParams(params))
        data = await response.json()
    } catch (e) {
        const err = new Error("Нет связи с сервером")
        err.code = 0
        throw err
    }
    if (!data || Number(data.response) <= 0) {
        const err = new Error((data && (data.desc || data.status)) || "Ошибка сервера")
        err.code = data ? Number(data.response) : -500
        throw err
    }
    return data
}

export const ChatApi = {
    dialogs: () => call("dialogs"),
    unread: () => call("unread"),
    messages: (dialogId, before, beforeId) => call("messages", { dialog_id: dialogId, before, before_id: beforeId }),
    read: (dialogId) => call("read", { dialog_id: dialogId }),
    send: (dialogId, text, clientId) => call("send", { dialog_id: dialogId, text, client_id: clientId })
}
